import React, { Component } from "react";
import { Typography } from "@material-ui/core";
import { datadogRum } from "@datadog/browser-rum";

type ErrorBoundaryProps = {};
type ErrorBoundaryState = {
  hasError: boolean;
};

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log("error", error);
    console.log("errorInfo", errorInfo);
    datadogRum.addError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <Typography variant="h6" style={{ padding: "12px 24px" }}>Something went wrong...</Typography>;
    }

    return this.props.children;
  }
}
